var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "rounded-card mt-20" },
    [
      false
        ? _c(
            "v-container",
            { attrs: { "grid-list-md": "" } },
            [
              _c(
                "FormFieldsContainer",
                { attrs: { titulo: "Planes de Mantenimiento" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { md6: "" } },
                    [
                      _c("BuscadorOperacionCrud", {
                        attrs: {
                          filter:
                            _vm.gridApi &&
                            _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { align: "left" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c("MantenedorGrid", {
                        attrs: {
                          "grid-options": _vm.gridOptionsPlanesMantenimiento
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _c(
            "FormFieldsContainer",
            {
              attrs: {
                titulo: "Asociar Plan de Mantenimiento y Pauta de Actividades"
              }
            },
            [
              _vm._t("prependAsociar"),
              _c(
                "v-flex",
                { attrs: { sm12: "", md6: "" } },
                [
                  _c("v-autocomplete", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          rules: {
                            required: !_vm.readonly
                          }
                        },
                        expression:
                          "{\n            rules: {\n              required: !readonly,\n            },\n          }"
                      }
                    ],
                    attrs: {
                      required: "",
                      disabled: _vm.readonly,
                      items: _vm.planesMantenimiento,
                      "item-text": "nombre",
                      "item-value": "id",
                      "no-data-text": "Sin resultados"
                    },
                    on: {
                      change: function($event) {
                        return _vm.handleChangePlan()
                      }
                    },
                    model: {
                      value: _vm.idplan,
                      callback: function($$v) {
                        _vm.idplan = $$v
                      },
                      expression: "idplan"
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { md6: "" } },
                [
                  _c("BuscadorOperacionCrud", {
                    attrs: {
                      filter:
                        _vm.gridApi &&
                        _vm.gridApi.setQuickFilter.bind(_vm.gridApi)
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { align: "left" } },
            [
              _c(
                "v-flex",
                [
                  _c("MantenedorGrid", {
                    attrs: {
                      "grid-options": _vm.gridOptionsPlanesMantenimiento
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }